import React from 'react';
import { 
  Building, Heart, Dumbbell, Camera,
  Utensils, ChefHat, Users, BookOpen, Activity, PartyPopper,
  Droplets, Music, Bed,
  Stethoscope, HeartPulse, Scissors, Sun,
  Bike, Coffee, PawPrint, Dumbbell as Gym, Users as Social, Trees,
  Shield, Car,
  ShowerHead
} from 'lucide-react';
import { TbMassage } from 'react-icons/tb';
import { FaPersonShelter } from 'react-icons/fa6';
import { MdOutlineLocalLaundryService, MdOutlineSportsTennis } from 'react-icons/md';
import { IoBasketballOutline } from 'react-icons/io5';

const AmenitiesSection = ({ className = "" }) => {
  const amenities = [
    {
      category: "Dignity Club House",
      icon: Building,
      items: [
        { name: "Dining room", icon: Utensils },
        { name: "Kitchen", icon: ChefHat },
        { name: "Guest Suit", icon: Users },
        { name: "Reading room", icon: BookOpen },
        { name: "Health Club", icon: Activity },
        { name: "Recreation Hall", icon: PartyPopper },
        { name: "Laundry", icon: MdOutlineLocalLaundryService },
        { name: "Pickleball Court", icon: MdOutlineSportsTennis },
        { name: "Swimming Pool", icon: Droplets },
        { name: "Amphitheatre", icon: Music },
        { name: "Multipurpose hall", icon: Bed },
        { name: "Party area", icon: PartyPopper },
      ]
    },
    {
      category: "Wellness Centre",
      icon: Heart,
      items: [
        { name: "Nursing station", icon: HeartPulse },
        { name: "Beauty Saloon", icon: Scissors },
        { name: "Doctor consultation", icon: Stethoscope },
        { name: "Open Yoga centre", icon: ShowerHead },
        { name: "Ayurveda massage centre", icon: TbMassage },
        { name: "Steam room", icon: Sun },
      ]
    },
    {
      category: "Sports & Recreation",
      icon: Dumbbell,
      items: [
        { name: "Bicycle Bay", icon: Bike },
        { name: "Jogging track", icon: Activity },
        { name: "Coffee bar", icon: Coffee },
        { name: "Pets Park", icon: PawPrint },
        { name: "Open Gym", icon: Gym },
        { name: "Socialising hub", icon: Social },
        { name: "Rain Pavilion", icon: FaPersonShelter },
        { name: "Half Basket ball court", icon: IoBasketballOutline },
        { name: "Landscaped garden and Park", icon: Trees },
      ]
    },
    {
      category: "Security & Services",
      icon: Camera,
      items: [
        { name: "24 hour security with CCTV Cameras", icon: Shield },
        { name: "Driver with car", icon: Car }
      ]
    }
  ];

  return (
    <div className={`pt-16 sm:pt-28 bg-gradient-to-b from-gray-50 to-white ${className}`}>
      <div className="max-w-6xl mx-auto px-3 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl  font-light text-gray-900 mb-6 tracking-tight">
            Experience Luxury Living
            <span className="block text-[var(--primarycolor)] font-normal mt-2">with Comprehensive Amenities</span>
          </h2>
          
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Designed for your comfort, health, and entertainment - every amenity crafted 
            to enhance your retirement lifestyle.
          </p>
        </div>

        {/* Compact Grid Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {amenities.map((category, index) => {
            const IconComponent = category.icon;
            
            return (
              <div 
                key={index}
                className="bg-white rounded-2xl border border-gray-200 overflow-hidden "
              >
                {/* Header */}
                <div className="bg-gradient-to-r from-red-50 to-white px-3 sm:px-6 py-6 border-b border-gray-100">
                  <div className="flex items-center gap-2 sm:gap-4">
                    <div className="w-12 sm:w-16 h-12 sm:h-16 bg-white rounded-xl flex items-center justify-center shadow-sm flex-shrink-0">
                      <IconComponent className="w-5 sm:w-8 h-5 sm:h-8 text-[var(--primarycolor)]" />
                    </div>
                    <div>
                      <h3 className="text-2xl font-semibold text-gray-900">
                        {category.category}
                      </h3>
                      <div className="w-12 h-1 bg-[var(--primarycolor)] rounded-full mt-2"></div>
                    </div>
                  </div>
                </div>

                {/* Compact Items Grid */}
                <div className="p-3 sm:p-6">
                  <div className="grid grid-cols-2 gap-2 sm:gap-3">
                    {category.items.map((item, itemIndex) => {
                      const ItemIcon = item.icon;
                      return (
                        <div
                          key={itemIndex}
                          className="group/item"
                        >
                          <div className="p-2 sm:p-3 bg-gray-50 rounded-lg border border-gray-200 hover:border-[var(--primarycolor)] hover:bg-red-50 transition-all duration-200">
                            <div className="flex items-center gap-2">
                              <ItemIcon className="w-4 h-4 text-[var(--primarycolor)] flex-shrink-0" />
                              <span className="text-sm text-gray-700 font-medium leading-tight">
                                {item.name}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AmenitiesSection;